module.exports = __webpack_public_path__ + "static/3a1bf2.png";